import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'MG',
  quote: 'En tres semanas mi hijo empezó a nombrar lo que siente en lugar de explotar. No lo puedo creer. Este material hace lo que mil conversaciones no lograron.',
  name: 'María G.',
  location: 'Bogotá',
  role: 'Mamá de adolescente de 14 años'
}, {
  initials: 'LP',
  quote: 'Lo usé en el aula y el cambio fue inmediato. Los chicos por fin tienen palabras para lo que les pasa. El Tomo del Volcán es el favorito de todos.',
  name: 'Laura P.',
  location: 'Buenos Aires',
  role: 'Docente de secundaria'
}, {
  initials: 'RM',
  quote: 'Mi hija de 16 años lo abrió sola. Sola. Y me pidió que lo hiciéramos juntas. Eso no tenía precio.',
  name: 'Rosa M.',
  location: 'Santiago de Chile',
  role: 'Mamá de adolescente'
}];
export function Testimonials1() {
  return <TestimonialsSection title="Lo que dicen quienes ya lo tienen" testimonials={data} data-id="element-266" />;
}